import React from 'react';

// LOT 79 · styles par page : Accueil, Recettes et Équipe ne chargent que leurs styles (lazyCoeur) ;
// tout autre écran ou feuille chargé à la demande attend aussi le paquet « toutes » (styles des autres pages), une seule fois.
const lazyReact = React.lazy;
let toutes = null;
export const chargerToutes = () => { if (!toutes) toutes = import('../styles/par-page/toutes'); return toutes; };
export const lazyCoeur = lazyReact;
React.lazy = (charger) => lazyReact(() => Promise.all([charger(), chargerToutes()]).then(([m]) => m));
